import { render, staticRenderFns } from "./DownloadClips.vue?vue&type=template&id=4f16e094&"
import script from "./DownloadClips.vue?vue&type=script&lang=js&"
export * from "./DownloadClips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports